export const RECEIVE_COLLEGE_DATA_FOR_STUDENT = 'RECEIVE_COLLEGE_DATA_FOR_STUDENT';

export const receiveCollegeDataForStudent = (collegeDataForStudent) => ({
  type: RECEIVE_COLLEGE_DATA_FOR_STUDENT,
  collegeDataForStudent,
});
